export enum SHARE_WITH {
  UNSHARED = 0,
  PRIVATE = 1,
  SHARED = 2,
  // PUBLIC = 3
}

export interface ShareLevel {
  id: SHARE_WITH;
  title: string;
  description: string;
  className: string;
  icon: string;
}

export const shareLevels: ShareLevel[] = [
  {
    id: SHARE_WITH.UNSHARED,
    title: $localize`No compartido`,
    description: $localize`Nadie salvo tú puede ver este panel personalizado`,
    className: 'share-with--unshared',
    icon: 'la-block',
  },
  {
    id: SHARE_WITH.PRIVATE,
    title: $localize`Privado`,
    description: $localize`Solo los usaurios especificados pueden ver este panel personalizado`,
    className: 'share-with--private',
    icon: 'la-lock',
  },
  {
    id: SHARE_WITH.SHARED,
    title: $localize`Compartido`,
    description: $localize`Cualquier usuario del equipo con el enlace puede ver este panel personalizado`,
    className: 'share-with--shared',
    icon: 'la-share-alt',
  },
  // {
  //   id: SHARE_WITH.PUBLIC,
  //   title: this.i18n('Público'),
  //   description:
  //     this.i18n('Cualquier usuario con el enlace puede ver este panel personalizado'),
  //   className: 'share-with--public',
  //   icon: 'la-users'
  // }
];

export const getShareLevel = (level: number) => {
  return shareLevels.find((l) => l.id === level) || {};
};
